module.exports = __webpack_public_path__ + "media/music/bells_0-6eb105af.mp3";